import React, { useState } from 'react'
import Header from '../components/header'
import { Helmet } from 'react-helmet'
import Footer from '../components/footer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCopy, faTrash } from "@fortawesome/free-solid-svg-icons";
import ParaphraseOutput from '../components/subCmponents/paraphraseOutput';

export default function Paraphrase() {

    let [input, setInput] = useState("");
    let [show, setShow] = useState(false);
    let [para, setPara] = useState("");

    const cleanJsonString = (str) => {
        if (!str) return '';
        // Remove Markdown code block syntax and any other non-JSON text
        return str.replace(/```json|```/g, '').trim();
    };

    let getData = async () => {
        setPara("");
        setShow(true);

        const prompt = `Generate a JSON object Paraphrase the following text in clear, fluent English while preserving its original meaning. Avoid repetition, improve sentence structure where needed, and make it sound natural and human-written: ${input}. Format:
{
"paraphrased_text": "AI is transforming our daily lives, reshaping how we work and engage with technology."
}`;
        let response = await fetch("https://toolisobackend.vercel.app/paraphrase",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ prompt })
            }
        )
        const newdata = await response.json();
        let rawData = newdata.candidates?.[0]?.content?.parts?.[0]?.text;
        let clearText = cleanJsonString(rawData);
        const parsed = JSON.parse(clearText);
        setPara(parsed);
        setShow(false);


    }
    let [copy, setCopy] = useState(false);
    let clearText = () => {
        setInput("");
        setPara("");
    }
    let copyText = () => {
        setCopy(copy = true);
        navigator.clipboard.writeText(para.paraphrased_text);
        setTimeout(() => {
            setCopy(copy = false);
        }, 2000);
    }

    return (
        <div>
            <Helmet>
                <html lang="en" />
                <title>AI Paraphrasing Tool – Reword Text Smartly & Instantly | Tooliso</title>
                <meta
                    name="description"
                    content="Reword any text instantly using Tooliso's free AI Paraphrasing Tool. Perfect for students, writers, and marketers. Choose from formal, casual, or creative tones and keep the original meaning intact."
                />
                <link rel="canonical" href="https://tooliso.com/ParapharaseAI" />

                <meta property="og:title" content="AI Paraphrasing Tool – Free Text Rewriter by Tooliso" />
                <meta
                    property="og:description"
                    content="Polish your writing, avoid plagiarism, or rewrite content for SEO using our AI-powered paraphraser. Fast, accurate, and tone-friendly."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://tooliso.com/ParapharaseAI" />

                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content="AI Paraphrasing Tool – Rewrite Smarter | Tooliso" />
                <meta
                    name="twitter:description"
                    content="Rephrase any content with Tooliso’s AI Paraphrasing Tool. Supports multiple writing styles and delivers clean, meaningful output instantly."
                />
            </Helmet>
            <Header />

            <div style={{ marginTop: "110px", padding: "2rem" }}>
                <div className="Knowlegdeinput-section">
                    <h2 className="Knowlegdetitle">AI Paraphrasing Tool</h2>
                    <p className="Knowlegdedescription">Paste your text to instantly generate a reworded version that keeps the original meaning but uses fresh phrasing.</p>

                    <textarea id="topicsInput" value={input} onChange={(e) => setInput(input = e.target.value)} placeholder="Paste your text here to paraphrase.
Example:
- The quick brown fox jumps over the lazy dog.
- Climate change is one of the most pressing issues of our time.
- Artificial Intelligence is transforming the way we work and live.
..."></textarea>

                    {
                        show ?
                            <div className="outerspin">
                                <div className='spinner'></div>
                            </div>
                            :
                            input == "" ?
                                <button id="generateBtn" className="Knowledgebtn nopoint">
                                    Paraphrase Now
                                </button>
                                :
                                <button id="generateBtn" onClick={getData} className="Knowledgebtn point">
                                    Paraphrase Now
                                </button>
                    }
                    {
                        para == "" ? "" :
                            <>
                                <ParaphraseOutput text={para.paraphrased_text} />
                                <div className="copyCounter">
                                    <button className='clearBtn' onClick={clearText}><FontAwesomeIcon icon={faTrash} />Clear Text</button>
                                    {
                                        copy ?
                                            <button className='copyBtn'><FontAwesomeIcon icon={faCheck} />Text Copied</button>
                                            :
                                            <button className='copyBtn' onClick={copyText}><FontAwesomeIcon icon={faCopy} />Copy Text</button>
                                    }
                                </div>
                            </>


                    }



                </div>
            </div>
            <Footer />
        </div>
    )
}
